export class Reparateur {
  relnr: string;
  rol: string;
  naam: string;
  adres: string;
}